import { render, staticRenderFns } from "./repayReportForAmountReal.vue?vue&type=template&id=2196e960&scoped=true&"
import script from "./repayReportForAmountReal.vue?vue&type=script&lang=js&"
export * from "./repayReportForAmountReal.vue?vue&type=script&lang=js&"
import style0 from "./repayReportForAmountReal.vue?vue&type=style&index=0&id=2196e960&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2196e960",
  null
  
)

export default component.exports